import React, { useState, createContext, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import CallbackHandler from './components/CallbackHandler';
import FileSystemSidebar from './components/FileSystemSidebar';
// Adjust import path for Search component. Since Search.js is located in the src folder
// (not in the components folder), import it directly from './Search'.
import Search from './Search';
import { themes } from './theme';
import './App.css';

// Create theme context
export const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

function App() {
  const [currentTheme, setCurrentTheme] = useState('synthwave');
  const theme = themes[currentTheme];

  // Apply theme CSS variables
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--bg-color', theme.colors.background);
    root.style.setProperty('--bg-color-2', theme.colors.background2);
    root.style.setProperty('--bg-color-3', theme.colors.background3);
    root.style.setProperty('--fg-color', theme.colors.foreground);
    root.style.setProperty('--accent-green', theme.colors.accentGreen);
    root.style.setProperty('--accent-cyan', theme.colors.accentCyan);
    root.style.setProperty('--accent-orange', theme.colors.accentOrange);
    root.style.setProperty('--accent-purple', theme.colors.accentPurple);
    root.style.setProperty('--border-color', theme.colors.border);
    root.style.setProperty('--shadow-color', theme.colors.shadow);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, currentTheme, setCurrentTheme, themes }}>
      <Router>
        <div style={{ backgroundColor: theme.colors.background3, minHeight: '100vh', padding: '20px' }}>
          <div style={{ display: 'flex', gap: '20px', maxWidth: '1400px', margin: '0 auto' }}>
            <FileSystemSidebar />
            <div className="app-container" style={{
              borderColor: theme.colors.border,
              backgroundColor: theme.colors.background,
              boxShadow: `0 0 15px ${theme.colors.shadow}`,
              flex: 1,
            }}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/callback" element={<CallbackHandler />} />
                <Route path="/" element={<Home />} />
                {/* Route for advanced search */}
                <Route path="/search" element={<Search />} />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    </ThemeContext.Provider>
  );
}

export default App;